export const timeAgo = (timestamp) => {
  const now = new Date()
  const diff = Math.floor((now - new Date(timestamp)) / 1000)

  const units = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 1 }
  ]

  for (const { label, seconds } of units) {
    const interval = Math.floor(diff / seconds)
    if (interval >= 1) {
      return `${interval} ${label}${interval > 1 ? 's' : ''} ago`
    }
  }
  return 'just now'
}

// Function to format game duration
export const formatDuration = (duration) => {
  const minutes = Math.floor(duration / 60)
  const seconds = duration % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export const analyzePerformance = (data) => {
  const { games, searchedName } = data

  let totalKills = 0; let totalDeaths = 0; let totalAssists = 0; let wins = 0; let losses = 0

  games.forEach(doc => {
    const participant = doc.participants.find(p => p.puuid === searchedName)
    if (participant) {
      participant.win ? wins++ : losses++
      totalKills += participant.stats.kills
      totalDeaths += participant.stats.deaths
      totalAssists += participant.stats.assists
    }
  })

  const totalGames = wins + losses
  const kda = totalDeaths > 0 ? (totalKills + totalAssists) / totalDeaths : Infinity

  return {
    totalKills,
    totalAssists,
    totalDeaths,
    totalGames,
    wins,
    losses,
    winRate: totalGames > 0 ? wins / totalGames : 0,
    overallKda: kda
  }
}
